module.exports = __webpack_public_path__ + "static/media/E18.f7321a8d.jpg";